import { InfoMessage } from "@components/backoffice/InfoMessage";
import { MetadataTable } from "@components/backoffice/MetadataTable";
import { ShowMoreContent } from "@components/ShowMoreContent";
import { prettyPrintBooleanValue } from "@components/utils";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Divider, Header } from "semantic-ui-react";

export class DocumentCuration extends Component {
  renderInternalNotes = () => {
    const { document } = this.props;

    if (!_isEmpty(document.metadata.internal_notes)) {
      return document.metadata.internal_notes.map((entry, index) => (
        <>
          User {entry.user} noted for field {entry.field}:<br />
          <p>{entry.value}</p>
          <br />
        </>
      ));
    }
  };

  render() {
    const { document } = this.props;
    const { metadata } = document;

    const hasNotes =
      !_isEmpty(metadata.note) || !_isEmpty(metadata.internal_notes);
    const hasLocation =
      !_isEmpty(metadata.sections) || !_isEmpty(metadata.call_number);

    if (!hasNotes && !hasLocation) {
      return (
        <InfoMessage
          header="No information."
          content="Edit document to add information"
        />
      );
    }

    const curationRows = [
      {
        name: "Curated",
        value: prettyPrintBooleanValue(metadata.curated),
      },
    ];

    const locationRows = [];

    if (!_isEmpty(metadata.sections)) {
      locationRows.push({
        name: "Library Section",
        value: metadata.sections,
      });
    }

    if (!_isEmpty(metadata.call_number)) {
      locationRows.push({
        name: "Call Number",
        value: metadata.call_number,
      });
    }

    return (
      <>
        {hasNotes && (
          <>
            {metadata.note && (
              <>
                <Header as="h3">Public note</Header>
                <ShowMoreContent content={metadata.note} lines={10} />
              </>
            )}

            {metadata.note && metadata.internal_notes && <Divider />}

            {metadata.internal_notes && (
              <>
                <Header as="h3">Internal notes</Header>
                {metadata.internal_notes.map((element, idx) => (
                  <React.Fragment key={idx}>
                    User {element.user} noted for field {element.field}:<br />
                    <p>{element.value}</p>
                    <br />
                  </React.Fragment>
                ))}
              </>
            )}

            <Divider />
          </>
        )}

        {hasLocation && (
          <>
            <Header as="h3">Location</Header>
            <MetadataTable rows={locationRows} />
            <Divider />
          </>
        )}

        <Header as="h3">Curation</Header>
        <MetadataTable rows={curationRows} />
      </>
    );
  }
}

DocumentCuration.propTypes = {
  document: PropTypes.object.isRequired,
};
